import React from 'react';
import { motion } from 'framer-motion';
import { Compass } from 'lucide-react';
import DestinationCard from './DestinationCard';
import { popularDestinations } from '../mock/destinations';

const PopularDestinations = () => {
  const handleDestinationSelect = (destination) => {
    console.log('Destino seleccionado:', destination);
  };

  return (
    <motion.section 
      className="py-12"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.4 }}
    >
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <Compass className="w-8 h-8 text-green-500" />
            <h2 className="text-3xl font-bold text-gray-800">
              Destinos Populares
            </h2>
          </div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Descubre los lugares más increíbles de Costa Rica con nuestro servicio de transporte seguro y confiable
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {popularDestinations.map((destination, index) => (
            <DestinationCard
              key={destination.id}
              destination={destination}
              onSelect={handleDestinationSelect}
              index={index}
            />
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default PopularDestinations;